(function () {
  const NO_DECIMAL_CURRENCIES = new Set([
    'BIF','BYR','CLP','DJF','GNF','ISK','JPY','KMF','KRW',
    'MGA','PYG','RWF','UGX','VND','VUV','XAF','XOF','XPF'
  ]);

  function formatMoney(cents, format, currency) {
    const noDecimal = NO_DECIMAL_CURRENCIES.has((currency || '').toUpperCase());
    const divisor = noDecimal ? 1 : 100;
    const precision = noDecimal ? 0 : 2;
    const raw = (cents / divisor).toFixed(precision);
    const [whole, frac] = raw.split('.');
    const wholeFormatted = whole.replace(/\d(?=(\d{3})+(?!\d))/g, '$&,');
    const amount = precision > 0 ? `${wholeFormatted}.${frac}` : wholeFormatted;
    const amountComma = precision > 0
      ? `${whole.replace(/\d(?=(\d{3})+(?!\d))/g, '$&.')},${frac}`
      : whole.replace(/\d(?=(\d{3})+(?!\d))/g, '$&.');

    return (format || '${{amount}}')
      .replace(/\{\{\s*amount\s*\}\}/, amount)
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/, wholeFormatted)
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, amountComma)
      .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/, whole.replace(/\d(?=(\d{3})+(?!\d))/g, '$&.'))
      .replace(/\{\{\s*currency\s*\}\}/, currency || '');
  }

  function updateBundleSelector(section, productId, variant, moneyFormat, currency) {
    const bundleSelector = section.querySelector(
      '.ch-bundle-selector[data-base-price][data-money-format][data-currency]'
    );
    if (!bundleSelector) return;

    const basePrice = Number(variant.price) || 0;
    bundleSelector.dataset.basePrice = String(basePrice);
    bundleSelector.dataset.moneyFormat = moneyFormat || bundleSelector.dataset.moneyFormat || '${{amount}}';
    bundleSelector.dataset.currency = currency || bundleSelector.dataset.currency || '';

    bundleSelector.querySelectorAll('.ch-bundle-option').forEach(function (option) {
      const quantity = Number(option.dataset.quantity || '1') || 1;
      const discount = Number(option.dataset.discount || '0') || 0;
      const original = basePrice * quantity;
      const total = Math.round(original * (100 - discount) / 100);
      const totalEl = option.querySelector('[data-bundle-total]');
      const compareEl = option.querySelector('[data-bundle-compare]');

      if (totalEl) totalEl.textContent = formatMoney(total, moneyFormat, currency);
      if (compareEl) compareEl.textContent = discount > 0 ? formatMoney(original, moneyFormat, currency) : '';
    });
  }

  document.addEventListener('variant:selected', function (event) {
    const variantPicker = event.target && event.target.closest
      ? event.target.closest('variant-picker')
      : null;
    if (!variantPicker) return;

    const productId = variantPicker.dataset.productId;
    const section = variantPicker.closest('.shopify-section');
    if (!section || !productId) return;

    // Collect currently selected option values from all fieldsets
    const fieldsets = variantPicker.querySelectorAll('fieldset[data-fieldset-index]');
    const selectedOptions = [];
    fieldsets.forEach(function (fieldset) {
      const checked = fieldset.querySelector('input:checked');
      if (checked) selectedOptions.push(checked.value);
    });
    if (selectedOptions.length === 0) return;

    // Read embedded variant price data
    const dataScript = section.querySelector(
      '.averoak-variant-prices-data[data-product-id="' + productId + '"]'
    );
    if (!dataScript) return;

    let variants, moneyFormat, currency;
    try {
      variants = JSON.parse(dataScript.textContent);
      moneyFormat = dataScript.dataset.moneyFormat || '${{amount}}';
      currency = dataScript.dataset.currency || 'USD';
    } catch (e) {
      return;
    }

    // Find the variant that matches all selected options
    const variant = variants.find(function (v) {
      for (let i = 0; i < selectedOptions.length; i++) {
        if (v['option' + (i + 1)] !== selectedOptions[i]) return false;
      }
      return true;
    });
    if (!variant) return;

    // Find the product-price element in this section
    const productPrice = section.querySelector(
      'product-price[data-product-id="' + productId + '"]'
    );
    if (!productPrice) return;

    const priceContainer = productPrice.querySelector('[ref="priceContainer"]');
    if (!priceContainer) return;

    const isOnSale = variant.compare_at_price > 0 && variant.compare_at_price > variant.price;
    const priceText = formatMoney(variant.price, moneyFormat, currency);
    const compareText = formatMoney(variant.compare_at_price, moneyFormat, currency);

    const regularDiv = priceContainer.querySelector('.price__regular');
    const saleDiv = priceContainer.querySelector('.price__sale');

    if (regularDiv && saleDiv) {
      if (isOnSale) {
        regularDiv.classList.add('price__hidden');
        saleDiv.classList.remove('price__hidden');
        const saleSpan = saleDiv.querySelector('.price-item--sale, .price');
        const compareSpan = saleDiv.querySelector('.compare-at-price');
        if (saleSpan) saleSpan.textContent = priceText;
        if (compareSpan) compareSpan.textContent = compareText;
      } else {
        regularDiv.classList.remove('price__hidden');
        saleDiv.classList.add('price__hidden');
        const regularSpan = regularDiv.querySelector('.price');
        if (regularSpan) regularSpan.textContent = priceText;
      }
    }

    updateBundleSelector(section, productId, variant, moneyFormat, currency);
  });

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.shopify-section').forEach(function (section) {
      const dataScript = section.querySelector('.averoak-variant-prices-data');
      const productPrice = section.querySelector('product-price[data-product-id]');
      const bundleSelector = section.querySelector('.ch-bundle-selector');
      if (!dataScript || !productPrice || !bundleSelector) return;

      try {
        const variants = JSON.parse(dataScript.textContent);
        const currentVariantId = section.querySelector('product-form-component input[name="id"]')?.value;
        const variant = variants.find(function (item) {
          return item.id?.toString() === currentVariantId?.toString();
        }) || variants[0];
        if (!variant) return;

        updateBundleSelector(
          section,
          productPrice.dataset.productId,
          variant,
          dataScript.dataset.moneyFormat || '${{amount}}',
          dataScript.dataset.currency || 'DKK'
        );
      } catch (e) {
        return;
      }
    });
  });
})();
